import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { MedicineInTakeApi } from '../api/medicineintake.api';
import { switchMap, map } from 'rxjs/operators';
import {  MedicineInTakeData,  MedicineInTake } from '../../../interfaces/masters/medicineintake' ;
@Injectable()
export class  MedicineInTakeService extends  MedicineInTakeData {

    constructor(private api:  MedicineInTakeApi) {
      super();
    }
  
  
    list(url: string): Observable< MedicineInTake[]> {
      return this.api.list(url);
    }
  
    getById(url:string): Observable< MedicineInTake>{
        return this.api.getById(url);
    }
  
    create(url: string, data: MedicineInTake): Observable< MedicineInTake[]> {
      return this.api.add(url,data);
    }
  
    update(url: string, data: MedicineInTake): Observable< MedicineInTake> {
      return this.api.update(url,data);
    }
  
    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
  